import { createFileRoute, redirect } from "@tanstack/react-router";
import { appendSearch } from "~/components/lock/lockServiceRoutes";

export const Route = createFileRoute("/$hubMetaName/lock/summary/$spaceId")({
	loader: (ctx) => {
		throw redirect({
			href: appendSearch(`/${ctx.params.hubMetaName}/swap/summary/${ctx.params.spaceId}`, ctx.location.searchStr),
			replace: true,
		});
	},
});
